import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center display-2 my-16 font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectComponent = _resolveComponent("ProjectComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    false
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "🎧 Podcasts"))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createBlock(_component_ProjectComponent, {
          key: 1,
          imgSrc: "/img/projects/essay-self-aware-software-artisan-technology-andromeda-mario-novak.webp",
          class: "my-16",
          headerLink: {
        name: '🇬🇧 Software Artisan Podcast: Question everything',
        href: 'https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/'
      },
          tags: [
        'Journaling',
        'Evaluating status and progress',
        'Adjusting your actions',
        'Choosing optimal solutions',
        'Improving yourself throughout time',
      ],
          descriptions: [
      ],
          points: [
        'To cut corners or to invest proper time to learn?',
        'Journaling',
        'Algorithms — chess for Technology enthusiasts',
        'Build as you learn',
        'Educational system',
        'Be able to play in an ever-changing World',
        'Scalable programming language',
        'Software Development',
      ],
          links: [
        {
          name: '📣 MixCloud',
          href: 'https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/',
        },
      ]
        }))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createBlock(_component_ProjectComponent, {
          key: 2,
          class: "my-16",
          headerLink: {
  name: '🇭🇷 Testing for Beginners',
        href: 'https://soundcloud.com/moltouni/testiranje-za-pocetnike-hack-the-balkan-1-typescript-frontend-backend-programiranje'
      },
          tags: [
        'Problem Decomposition',
        'Data Mocking',
        'Test Driven Development',
        'TypeScript',
        'Frontend',
        'Backend',
      ],
          descriptions: [
      ],
          points: [
          'Why do we test our apps?',
          'Which parts should we test?',
          'Problem Decomposition.',
          'Data mocking.',
      ],
          links: [
        {
          name: 'SoundCloud',
          href: 'https://soundcloud.com/moltouni/testiranje-za-pocetnike-hack-the-balkan-1-typescript-frontend-backend-programiranje',
        },
      ]
        }))
      : _createCommentVNode("", true)
  ]))
}